import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// style.scss
import 'assets/style.css';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// apex-chart
import 'assets/third-party/apex-chart.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from '@components/Locales';
import RTLLayout from '@components/RTLLayout';
import ScrollTop from '@components/ScrollTop';
import CookieBanner from '@components/CookieBanner';
import Snackbar from '@components/@extended/Snackbar';
import Notistack from '@components/third-party/Notistack';
import Metrics from 'metrics';

// auth-provider
import { JWTProvider as AuthProvider } from '@contexts/JWTContext';
import { CommonProvider } from '@contexts/CommonContext';
import { ConfigProvider } from 'contexts/ConfigContext';

export default function MainApp() {
  return (
    <ConfigProvider>
      <HelmetProvider>
        <CommonProvider>
          <ThemeCustomization>
            <RTLLayout>
              <Locales>
                <ScrollTop>
                  <AuthProvider>
                    <CommonProvider>
                      <Notistack>
                        <RouterProvider router={router} />
                        <CookieBanner />
                        <Snackbar />
                      </Notistack>
                    </CommonProvider>
                  </AuthProvider>
                </ScrollTop>
              </Locales>
            </RTLLayout>
          </ThemeCustomization>
          <Metrics />
        </CommonProvider>
      </HelmetProvider>
    </ConfigProvider>
  );
}
